import "../../../css/IconStyle.css";
import { GrStatusWarning, GrServices } from "react-icons/gr";

export const IssueIcon = () => {
  return <GrStatusWarning size={22} className="sidebar-icon" />;
};

export const ServiceIcon = () => {
  return <GrServices size={22} className="sidebar-icon" />;
};